/**
 * Removes the background from an uploaded image entirely in the browser
 * (via @imgly/background-removal — WASM/ONNX, no server round-trip, no
 * third-party API key). Falls back to the original file with a warning if
 * the model fails to load or the removal call throws.
 */
export interface BackgroundRemovalResult {
  file: File;
  warning?: string;
}

const FALLBACK_WARNING =
  'This image contains a background. Please upload a transparent PNG/SVG for best results.';

export async function removeImageBackground(file: File): Promise<BackgroundRemovalResult> {
  try {
    const { removeBackground } = await import('@imgly/background-removal');
    const blob = await removeBackground(file);
    const name = file.name.replace(/\.[^./\\]+$/, '') + '.png';
    return { file: new File([blob], name, { type: 'image/png' }) };
  } catch {
    return { file, warning: FALLBACK_WARNING };
  }
}
